<template>
  <div class="accout-overview-header">
    <el-row>
      <el-col :span="24">
        <div class="page-title">
          {{ $t('merchant.account_balance') }}
        </div>
      </el-col>
    </el-row>
    <div class="balance-content">
      <div>
        <div class="accout-overview-header-content">

          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.balance_available') }}
              <el-tooltip placement="top">
                <div slot="content" style="width: 300px">
                  <span>{{ $t('tips.dashboard_balance_question') }}</span>
                </div>
                <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
              </el-tooltip>
            </div>
            <div class="num">
              {{ $store.getters.currency }}
              {{ balanceInfo.balance | toDivideWithDot }}
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div>
                    <span>{{ $t('tips.dashboard_balance_number') }}  {{ balanceInfo.available_withdraw | toDivideWithDot }} {{ $store.getters.currency }}</span>
                  </div>
                  <template v-if="balanceInfo.nsds_status">
                    <div>
                      <span>{{ $t('tips.nsds_balance') }}:  {{ balanceInfo.nsds_balance | toDivideWithDot }} {{ $store.getters.currency }}</span>
                    </div>
                    <div>
                      <span>{{ $t('tips.nsds_credit_limit') }}:  {{ balanceInfo.current_nsds_credit_limit | toDivideWithDot }} {{ $store.getters.currency }}</span>
                    </div>
                    <div v-if="hasPendingNsdsCreditLimit">
                      <svg-icon icon-class="icon-font-warning" style="color: #F67C7C;" />
                      <span>{{ $t('tips.nsds_credit_limit_pending_prefix') }} {{ balanceInfo.pending_nsds_credit_limit | toDivideWithDot }} {{ $store.getters.currency }}{{ $t('tips.nsds_credit_limit_pending_suffix') }}</span>
                    </div>
                  </template>
                </div>
                <span>  <svg-icon icon-class="icon-font-warning" class="icon-warning" /></span>
              </el-tooltip>

            </div>
          </div>
          <div class="line" />
          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.amount_in_transit') }}</div>
            <div class="num">
              {{ $store.getters.currency }}
              {{ balanceInfo.fund_settlement_amount | toDivideWithDot }}
            </div>
          </div>
          <div class="line" />
          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.amount_adb') }}</div>
            <div class="num">
              {{ $store.getters.currency }}
              {{ balanceInfo.adb_amount | toDivideWithDot }}
            </div>
          </div>
        </div>
      </div>
      <div class="balance-operate">
        <el-button type="info" @click="onClickRechargeBtn">
          {{ $t('merchantAccount.top_up') }}
        </el-button>

        <template v-if="showCashOut && withdrawInfo.withdraw_type === 1">
          <el-tooltip v-if="shouldDisableWithdraw" placement="top">
            <div slot="content">
              {{ $t('merchantAccount.cash_out_threshold') }}: {{ currentWithdrawThreshold | toThousandFilter }} {{ $store.getters.currency }}<br>
            </div>
            <el-button type="info" plain disabled>
              {{ $t('merchantAccount.cash_out') }}
            </el-button>
          </el-tooltip>
          <el-button v-else type="info" plain @click="onClickWithDrawBtn">
            {{ $t('merchantAccount.cash_out') }}
          </el-button>
        </template>

        <!--        <el-button v-if="$store.getters.isID" type="info" plain @click="onClickTransBtn">-->
        <!--          {{ $t('data.transfer') }}-->
        <!--        </el-button>-->

        <div class="line2" />
        <div @click="onClickBalanceDetailTxt">
          <span class="balance-detail-txt">{{ $t('data.balance_details') }}</span>
        </div>
      </div>
    </div>
    <WithdrawModal ref="withdrawModalRef" :withdraw-threshold="currentWithdrawThreshold" :balance-info="balanceInfo" @get-merchant-info="getMerchantInfo" />
    <TransModal ref="transModalRef" :merchant-info="merchantInfo" :balance="balanceInfo.balance" @get-merchant-info="getMerchantInfo" />
    <ApplicationIdentityCheckModal ref="applicationIdentityCheckModal" />
  </div>
</template>

<script>
import { fetchMerchantInfo, getWithdrawThreshold } from '@/api/merchant-manage/merchant-manage'
import { fetchSettlementBank } from '@/api/system/system'
import { fetchWithdrawType, fetchNeedSupplementStatus, fetchWithdrawStatus } from '@/api/system/system.js'
export default {
  name: 'Merchant_Withdraw_Recharge',
  components: {
    WithdrawModal: () => import('../Modal/WithdrawModal.vue'),
    TransModal: () => import('../Modal/TransModal.vue'),
    ApplicationIdentityCheckModal: () => import('@/views/paycools/develop-manage/components/Modal/ApplicationIdentityCheckModal.vue')
  },
  data() {
    return {
      showCashOut: true,
      balanceInfo: { balance: 0 },
      withdrawStatus: '',
      isMFACompleted: false,
      merchantInfo: {},
      withdrawInfo: {},
      isNeedSupplementStatus: false,
      merchant: this.$store.getters.userInfo.merchant ?? {},
      countryWithdrawThresholds: {
        RU: 4300000 // 可扩展其他国家的阈值
      }
    }
  },
  computed: {
    hasPendingNsdsCreditLimit() {
      const limit = this.balanceInfo.pending_nsds_credit_limit
      return limit !== undefined && limit !== null && limit !== ''
    },
    currentWithdrawThreshold() {
      const countryCode = this.$store.getters.curCountry?.country_code
      return this.countryWithdrawThresholds[countryCode] || 0
    },
    shouldDisableWithdraw() {
      const countryCode = this.$store.getters.curCountry?.country_code
      return this.countryWithdrawThresholds.hasOwnProperty(countryCode) &&
        this.balanceInfo.available_withdraw < this.currentWithdrawThreshold
    },
    kycStatus() {
      const merchantInfo =
        this.$store.getters.userInfo &&
        this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status
    }
  },
  created() {
    this.getMerchantInfo()
    this.getMchDetail()
    this.getWithdrawType()
    this.getWithdrawThreshold()
    // this.getNeedSupplementStatus()
    this.getWithdrawStatus()
    this.getWithdrawThreshold()
  },
  methods: {
    getWithdrawStatus() {
      fetchWithdrawStatus().then(res => {
        const { data } = res
        if (data) {
          this.withdrawStatus = data.withdraw_status
        }
      })
    },
    getMchDetail() {
      fetchSettlementBank().then(res => {
        if (res.data) {
          this.showCashOut = !res.data.length
        }
      })
    },
    getWithdrawThreshold() {
      getWithdrawThreshold().then(res => {
        const { withdraw_threshold, country_code } = res.data
        const toDivide100 = this.$options.filters['toDivide100']
        this.countryWithdrawThresholds = {
          [country_code]: toDivide100(withdraw_threshold)
        }
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { code, data } = res
        if (data) {
          this.withdrawInfo = data
        }
      })
    },
    getNeedSupplementStatus() {
      fetchNeedSupplementStatus().then(res => {
        const { code, data } = res
        this.isNeedSupplementStatus = data
      })
    },
    getMerchantInfo() {
      fetchMerchantInfo().then(res => {
        const { merchant = {}, balance } = res.data
        const { merchant_basic_info, withdraw_fee_status } = merchant
        this.balanceInfo = balance || {}
        this.merchantInfo = { ...merchant_basic_info, withdraw_fee_status }
      })
    },
    onClickBalanceDetailTxt() {
      this.$router.push({ name: 'Financial_Manage_Balance_Detail' })
    },
    onClickRechargeBtn() {
      this.checkKycAndProceed(() => {
        this.$router.push({ name: 'Financial_Manage_Balance_Recharge' })
      })
    },
    onClickWithDrawBtn() {
      if (this.withdrawStatus !== 1) {
        this.$message.warning('You are not allowed to cash out')
        return
      }
      this.checkKycAndProceed(() => {
        if (this.$refs.withdrawModalRef) {
          this.$refs.withdrawModalRef.changModalStatus(true)
        }
      })
    },
    onClickTransBtn() {
      this.checkKycAndProceed(() => {
        if (this.$refs.transModalRef) {
          this.$refs.transModalRef.changModalStatus(true)
        }
      })
    },
    checkKycAndProceed(callback) {
      if (this.kycStatus === 1 || this.kycStatus === 2 || this.kycStatus === 4) {
        this.$store.commit('app/SET_PENDING_POPUP', true)
        return
      }
      typeof callback === 'function' && callback()
    },
    // methods callable from parent
    openWithdrawModal() {
      if (this.$refs.withdrawModalRef) {
        this.$refs.withdrawModalRef.changModalStatus(true)
      }
    },
    openTransModal() {
      if (this.$refs.transModalRef) {
        this.$refs.transModalRef.changModalStatus(true)
      }
    }
  }
}
</script>
<style scoped lang="scss">

.accout-overview-header{
  padding-bottom: 32px;
  border-bottom: 1px solid #D3D7DF;
  &-content{
    .num-container{
      display: inline-block;
      margin-bottom: 14px;
      .txt{
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: #4B5567;
      }
      .num{
        font-size: 24px;
        font-weight: 600;  font-family: 'Inter-SemiBold';
        line-height: 1.2;
        color:  #3855F1;
      }
    }

  }
  .line{
    display: inline-block;
    margin:0 24px;
    width: 1px;
    height: 60px;
    background:#D3D7DF;
    vertical-align: -4px;
  }
  .line2{
    display: inline-block;
    margin:0 15px;
    width: 1px;
    height: 32px;
    background:#D3D7DF;
  }
  .balance-detail-txt{
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #1D3A71;
    cursor: pointer;
    text-decoration: underline;
  }
}
.balance-content{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.balance-operate{
  display: flex;
  align-items: center;
}
.icon-question{
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
.icon-warning{
  font-size: 15px;
  position: relative;
  top: -4px;
  cursor: pointer;
}

</style>
